export default "__VITE_ASSET__BrEIkEyC__"